import {
  NotificationFrequency,
  NotificationSendBy,
  NotificationStatus,
  NotificationCampaignType
} from '@enums';

export interface RecurrenceConfig {
  weekday?: number;
  nth_weekday?: number;
  month_day?: number;
  weekdays?: string[];
}

export class NotificationCampaignDto {
  id: number = 0;
  title: string = '';
  message: string = '';
  send_to: string = '';
  send_to_display: string = '';
  send_by: NotificationSendBy = NotificationSendBy.PUSH;
  status: NotificationStatus = NotificationStatus.SENT;
  notification_type: NotificationCampaignType = NotificationCampaignType.CUSTOM;
  users: (string | number)[] = [];
  driver_ids: number[] = [];
  client_user_ids: number[] = [];
  transport_id: number | null = null;
  recipient_count: number = 0;
  notification_count: number = 0;
  read_count: number = 0;
  scheduled_task_id: number | null = null;
  repeat: boolean = false;
  frequency: NotificationFrequency | null = null;
  every: number = 1;
  recurrence: RecurrenceConfig | null = null;
  timezone: string = 'Europe/Madrid';
  start_at: string | null = null;
  ends_at: string | null = null;
  max_occurrences: number | null = null;
  sent_count: number = 0;
  created_date: string = '';

  constructor(data: Partial<NotificationCampaignDto> = {}) {
    Object.assign(this, data);
  }

  static fromJson(json: any): NotificationCampaignDto {
    const dto = new NotificationCampaignDto();
    if (!json) return dto;

    dto.id = json.id ?? 0;
    dto.title = json.title ?? '';
    dto.message = json.message ?? '';
    dto.send_to = json.send_to ?? '';
    dto.send_to_display = json.send_to_display ?? '';
    dto.send_by = json.send_by ?? 'PUSH';
    dto.status = json.status ?? 'SENT';
    dto.notification_type = json.notification_type ?? 'CUSTOM';
    dto.users = json.users ?? [];
    dto.driver_ids = json.driver_ids ?? [];
    dto.client_user_ids = json.client_user_ids ?? [];
    dto.transport_id = json.transport_id ?? null;
    dto.recipient_count = json.recipient_count ?? 0;
    dto.notification_count = json.notification_count ?? 0;
    dto.read_count = json.read_count ?? 0;
    dto.scheduled_task_id = json.scheduled_task_id ?? null;
    dto.repeat = json.repeat ?? false;
    dto.frequency = json.frequency ?? null;
    dto.every = json.every ?? 1;
    dto.recurrence = json.recurrence ?? null;
    dto.timezone = json.timezone ?? 'Europe/Madrid';
    dto.start_at = json.start_at ?? null;
    dto.ends_at = json.ends_at ?? null;
    dto.max_occurrences = json.max_occurrences ?? null;
    dto.sent_count = json.sent_count ?? 0;
    dto.created_date = json.created_date ?? '';

    return dto;
  }

  toJson(): any {
    return { ...this };
  }
}

export class NotificationCampaignListResponseDto {
  count: number = 0;
  total_pages: number = 0;
  next: string | null = null;
  previous: string | null = null;
  results: NotificationCampaignDto[] = [];

  constructor(data: Partial<NotificationCampaignListResponseDto> = {}) {
    Object.assign(this, data);
  }

  static fromJson(json: any): NotificationCampaignListResponseDto {
    const dto = new NotificationCampaignListResponseDto();
    if (!json) return dto;

    dto.count = json.count ?? 0;
    dto.total_pages = json.total_pages ?? 0;
    dto.next = json.next ?? null;
    dto.previous = json.previous ?? null;
    dto.results = (json.results || []).map((item: any) => NotificationCampaignDto.fromJson(item));

    return dto;
  }
}
